/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Trial_TextInputs */

const en_image_export_trial_text = /** @type {(inputs: Image_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for trying Closed Caption Creator. Your subscription is currently running in Trial Mode. Exported images will contain the word TRIAL. Would you like to activate your account in order to remove this restriction?`)
};

const fr_image_export_trial_text = /** @type {(inputs: Image_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci d'essayer Closed Caption Creator. Votre abonnement est actuellement en mode d'essai. Les images exportees contiendront le mot TRIAL. Souhaitez-vous activer votre compte afin de supprimer cette restriction ?`)
};

const de_image_export_trial_text = /** @type {(inputs: Image_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vielen Dank, dass Sie Closed Caption Creator ausprobiert haben. Ihr Abonnement befindet sich derzeit im Testmodus. Exportierte Bilder enthalten den Hinweis „TESTVERSION“. Möchten Sie Ihr Konto aktivieren, um diese Einschränkung aufzuheben?`)
};

const it_image_export_trial_text = /** @type {(inputs: Image_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grazie per aver provato Closed Caption Creator. Il tuo abbonamento è attualmente in modalità di prova. Le immagini esportate conterranno la parola "PROVA". Desideri attivare il tuo account per rimuovere questa restrizione?`)
};

const ru_image_export_trial_text = /** @type {(inputs: Image_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спасибо за использование Closed Caption Creator. Ваша подписка в настоящее время находится в пробном режиме. Экспортированные изображения будут содержать слово TRIAL. Хотите ли вы активировать свою учетную запись, чтобы снять это ограничение?`)
};

const es_image_export_trial_text = /** @type {(inputs: Image_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gracias por probar el Creador de Subtítulos. Su suscripción está actualmente en modo de prueba. Las imágenes exportadas contendrán la palabra PRUEBA. ¿Desea activar su cuenta para eliminar esta restricción?`)
};

const zh_cn2_image_export_trial_text = /** @type {(inputs: Image_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`感谢您试用字幕创建器。您的订阅目前处于试用模式。导出的图片会显示“试用”字样。您是否想激活您的帐户以解除此限制？`)
};

const ja_image_export_trial_text = /** @type {(inputs: Image_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed Caption Creator をお試しいただきありがとうございます。現在、お客様のサブスクリプションはトライアルモードです。エクスポートされた画像には「TRIAL」という文字が含まれます。この制限を解除するには、アカウントを有効化しますか？`)
};

const hi_image_export_trial_text = /** @type {(inputs: Image_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लोज्ड कैप्शन क्रिएटर को आज़माने के लिए धन्यवाद। आपकी सदस्यता वर्तमान में ट्रायल मोड में चल रही है। निर्यात की गई छवियों में TRIAL शब्द दिखाई देगा। क्या आप इस प्रतिबंध को हटाने के लिए अपना खाता सक्रिय करना चाहेंगे?`)
};

const pt_pt2_image_export_trial_text = /** @type {(inputs: Image_Export_Trial_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrigado por experimentar o Closed Caption Creator. Sua assinatura está atualmente em Modo de Avaliação. As imagens exportadas conterão a palavra "AVALIAÇÃO". Deseja ativar sua conta para remover essa restrição?`)
};

/**
* | output |
* | --- |
* | "Thank you for trying Closed Caption Creator. Your subscription is currently running in Trial Mode. Exported images will contain the word TRIAL. Would you lik..." |
*
* @param {Image_Export_Trial_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_trial_text = /** @type {((inputs?: Image_Export_Trial_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Trial_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_trial_text(inputs)
	if (locale === "de") return de_image_export_trial_text(inputs)
	if (locale === "it") return it_image_export_trial_text(inputs)
	if (locale === "ru") return ru_image_export_trial_text(inputs)
	if (locale === "es") return es_image_export_trial_text(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_trial_text(inputs)
	if (locale === "ja") return ja_image_export_trial_text(inputs)
	if (locale === "hi") return hi_image_export_trial_text(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_trial_text(inputs)
	return en_image_export_trial_text(inputs)
});